module.exports = __webpack_public_path__ + "img/y- (11).b9f15573.png";